<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><i>For Martin Gardner</i></p>
<p class="copyright1">STERLING and the distinctive Sterling logo are registered trademarks of<br/>Sterling Publishing Co., Inc.</p>
<p class="copyright1"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="copyright2">Pickover, Clifford A.<br/>  The math book / Clifford A. Pickover.<br/>p. cm.</p>
<p class="copyright3">ISBN 978-1-4027-5796-9<br/>1. Mathematics–History. I. Title.<br/>QA21.P53 2009<br/>510.9–dc22</p>
<p class="copyright4">2008043214</p>
<p class="copyright1">Published by Sterling Publishing Co., Inc.<br/>387 Park Avenue South, New York, NY 10016<br/>© 2009 by Clifford A. Pickover</p>
<p class="copyright5"><i>All rights reserved</i></p>
<p class="copyright1">Sterling ISBN 978-1-4027-9749-1</p>
<p class="copyright6">For information about custom editions, special sales, premium and<br/>corporate purchases, please contact Sterling Special Sales Department at 800–805–5489 or specialsales@sterlingpublishing.com.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// crt.vue?eb0b0406